<template>
  <v-container>
    <h2
      class="hidden-lg-and-up mx-5 mb-5 font-weight-light"
      style="color: #333"
    >{{ this.$route.name }}</h2>

    <v-row justify="center">
      <v-col cols="12" md="6" lg="5" xl="4">
        <v-card class="pa-10 ma-5" light>
          <v-card-text class="text-center">
            <v-avatar color="grey" size="200">
              <img v-if="imageUrl != ''" :src="imageUrl" />
              <span v-else class="white--text">Foto</span>
            </v-avatar>
          </v-card-text>

          <v-card-text class="text-center">
            <h4 class="display-2 font-weight-light mb-3 black--text">{{ firstName }} {{ lastName }}</h4>
            <p class="font-weight-light grey--text">{{ role }} MCC {{ selectArea }}</p>
            <v-btn color="red" rounded class="mr-0" dark>{{ accessLevel }}</v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="7" xl="8">
        <v-card class="pa-10 ma-5" light>
          <v-sheet class="v-sheet--offset mx-auto" color="success" elevation="12">
            <div class="User-Profile-Title">
              <div class="display-2 font-weight-light">Edit Profile</div>
              <div class="subtitle-1 font-weight-light">Complete your profile</div>
            </div>
          </v-sheet>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="accessLevel" label="Access Level" disabled />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field v-model="username" label="User Name" />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field v-model="email" label="Email Address" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model="firstName" label="First Name" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model="lastName" label="Last Name" />
                </v-col>

                <v-col cols="12">
                  <v-select v-model="selectArea" :items="areaItems" label="Area"></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field v-model="role" label="Role" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-select v-model="selectStatus" :items="statusItems" label="Status"></v-select>
                </v-col>

                <v-col cols="12">
                  <v-textarea label="About Me" v-model="aboutMe" />
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn color="success" class="mr-0">Update Profile</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UserProfile",
  data() {
    return {
      accessLevel: "Area Admin",
      username: "chrysanlim",
      email: "jkimccbsd@gmail.com",
      firstName: "Chrysan",
      lastName: "Lim",
      selectArea: "BSD",
      areaItems: ["Pusat", "Slipi", "Kwitang", "BSD", "Tangerang", "Bekasi"],
      role: "Head of Secretary",
      selectStatus: "Full-time",
      statusItems: ["Full-time", "Part-time", "Volunteer"],
      aboutMe:
        "Don't be scared of the truth because we need to restart the human foundation in truth.",
      imageUrl:
        "https://scontent-xsp1-2.xx.fbcdn.net/v/t1.0-9/18194011_10213562606445821_2427077512187702614_n.jpg?_nc_cat=104&_nc_sid=85a577&_nc_eui2=AeFQM1T88A3_r3u7_1HqF7HksVbXOADg5f2xVtc4AODl_RL75tKoq4a1YzA-qgvBn5E&_nc_ohc=0leoPaiZjeAAX8GJpnC&_nc_ht=scontent-xsp1-2.xx&oh=fd3d7a7543414b7d9a1fd0304bef71f7&oe=5ECF8671"
    };
  }
};
</script>

<style scoped>
.v-sheet--offset {
  top: -64px;
  position: relative;
}

.User-Profile-Title {
  padding: 25px;
  color: whitesmoke;
}
</style>